import React, { ReactNode, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router';

import { usePosthogEvents } from '~/services/tracking/posthog/use-posthog-events/usePosthogEvents';
import { useUser } from '~/stores/use-user/useUser';

import { appPaths } from '../../routes/app-paths';
import { queryKeys } from '../../routes/query-params';

interface AppHistoryProps {
  children: ReactNode;
}

export const AppHistory = (props: AppHistoryProps) => {
  const { user } = useUser(({ user }) => ({ user }));
  const location = useLocation();
  const navigate = useNavigate();
  const { trackDashboardOpen } = usePosthogEvents();

  useEffect(() => {
    if (user) {
      const queryParams = new URLSearchParams(location.search);
      const redirectTo = queryParams.get(queryKeys.redirect);

      if (redirectTo) {
        const isRedirectToDashboard = redirectTo === appPaths.base;

        if (isRedirectToDashboard) {
          trackDashboardOpen('login');
        }

        navigate(redirectTo, { replace: true });
        return;
      }
    }
  }, [location, user, navigate]);

  return <>{props.children}</>;
};
